import { Controller } from "@hotwired/stimulus"

// Dashboard widget controller for drag-and-drop, resize, refresh
// Connects to data-controller="dashboard-widget"
export default class extends Controller {
  static targets = ["content", "loader", "refreshBtn"]
  static values = {
    widgetId: String,
    refreshUrl: String,
    autoRefresh: { type: Number, default: 0 }
  }

  connect() {
    if (this.autoRefreshValue > 0) {
      this.startAutoRefresh()
    }
    this.element.setAttribute("draggable", "true")
    this.element.addEventListener("dragstart", this.dragStart.bind(this))
    this.element.addEventListener("dragend", this.dragEnd.bind(this))
  }

  disconnect() {
    this.stopAutoRefresh()
  }

  async refresh() {
    if (!this.refreshUrlValue) return

    this.showLoader()
    try {
      const response = await fetch(this.refreshUrlValue, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      if (response.ok) {
        const html = await response.text()
        if (this.hasContentTarget) {
          this.contentTarget.innerHTML = html
        }
      }
    } catch (error) {
      console.error("Widget refresh failed:", error)
    } finally {
      this.hideLoader()
    }
  }

  startAutoRefresh() {
    this.refreshInterval = setInterval(() => {
      this.refresh()
    }, this.autoRefreshValue * 1000)
  }

  stopAutoRefresh() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  }

  showLoader() {
    if (this.hasLoaderTarget) this.loaderTarget.classList.remove("hidden")
    if (this.hasContentTarget) this.contentTarget.classList.add("opacity-50")
  }

  hideLoader() {
    if (this.hasLoaderTarget) this.loaderTarget.classList.add("hidden")
    if (this.hasContentTarget) this.contentTarget.classList.remove("opacity-50")
  }

  dragStart(e) {
    e.dataTransfer.setData("text/plain", this.widgetIdValue)
    this.element.classList.add("opacity-50", "ring-2", "ring-mod-primary")
  }

  dragEnd() {
    this.element.classList.remove("opacity-50", "ring-2", "ring-mod-primary")
  }

  toggleCollapse() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden")
    }
  }
}
